import { useState } from 'react'
import axios from 'axios'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
//const API = `${BACKEND_URL}/api`
const API =
  "https://tmrglobalpublicweb-api-ajd4chh0dda8bwg9.australiaeast-01.azurewebsites.net/api"

const INITIAL = {
  firstName: '',
  lastName: '',
  workEmail: '',
  company: '',
  jobTitle: '',
  phone: '',
  country: '',
  companySize: '',
  interest: 'QC4 GRC Platform',
  preferredTime: '',
  message: '',
}

export default function DemoForm() {
  const [form, setForm] = useState(INITIAL)
  const [status, setStatus] = useState('idle') // idle | submitting | success | error
  const [errorMsg, setErrorMsg] = useState('')
  const [successMsg, setSuccessMsg] = useState('')

  const onChange = (e) => {
    const { name, value } = e.target
    setForm((f) => ({ ...f, [name]: value }))
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setStatus('submitting')
    setErrorMsg('')
    try {
      const { data } = await axios.post(
        `${API}/webform/submit`,
        { formType: 'Demo Request', ...form },
        { headers: { 'Content-Type': 'application/json' } },
      )
      setSuccessMsg(data?.message || "Thanks — we'll be in touch shortly.")
      setStatus('success')
      setForm(INITIAL)
    } catch (err) {
      const detail = err?.response?.data?.detail
      setErrorMsg(
        Array.isArray(detail)
          ? detail.map((d) => d?.msg || 'Invalid input').join(', ')
          : typeof detail === 'string'
          ? detail
          : 'Something went wrong. Please try again or email daniel.benson@tmrglobal.com.',
      )
      setStatus('error')
    }
  }

  return (
    <form className="qc-form" onSubmit={onSubmit} data-testid="demo-form" noValidate>
      <h3>Book your QC4 demo</h3>
      <p className="qc-form-sub">Tell us about your team — we&apos;ll tailor a 30-minute walkthrough.</p>

      <div className="qc-form-row">
        <div className="qc-field">
          <label htmlFor="firstName">First name</label>
          <input
            id="firstName" name="firstName" type="text" required
            value={form.firstName} onChange={onChange}
            placeholder="Jane"
            data-testid="demo-firstName"
          />
        </div>
        <div className="qc-field">
          <label htmlFor="lastName">Last name</label>
          <input
            id="lastName" name="lastName" type="text" required
            value={form.lastName} onChange={onChange}
            placeholder="Whitmore"
            data-testid="demo-lastName"
          />
        </div>
      </div>

      <div className="qc-form-row">
        <div className="qc-field">
          <label htmlFor="workEmail">Work email</label>
          <input
            id="workEmail" name="workEmail" type="email" required
            value={form.workEmail} onChange={onChange}
            placeholder="jane@company.com"
            data-testid="demo-workEmail"
          />
        </div>
        <div className="qc-field">
          <label htmlFor="phone">Phone</label>
          <input
            id="phone" name="phone" type="tel"
            value={form.phone} onChange={onChange}
            placeholder="+61 400 000 000"
            data-testid="demo-phone"
          />
        </div>
      </div>

      <div className="qc-form-row">
        <div className="qc-field">
          <label htmlFor="company">Company</label>
          <input
            id="company" name="company" type="text" required
            value={form.company} onChange={onChange}
            placeholder="Acme Financial"
            data-testid="demo-company"
          />
        </div>
        <div className="qc-field">
          <label htmlFor="jobTitle">Role</label>
          <input
            id="jobTitle" name="jobTitle" type="text"
            value={form.jobTitle} onChange={onChange}
            placeholder="Head of Risk"
            data-testid="demo-jobTitle"
          />
        </div>
      </div>

      <div className="qc-form-row">
        <div className="qc-field">
          <label htmlFor="companySize">Company size</label>
          <select id="companySize" name="companySize" value={form.companySize} onChange={onChange} data-testid="demo-companySize">
            <option value="">Select…</option>
            <option value="1-50">1–50</option>
            <option value="51-200">51–200</option>
            <option value="201-1000">201–1,000</option>
            <option value="1001-5000">1,001–5,000</option>
            <option value="5000+">5,000+</option>
          </select>
        </div>
        <div className="qc-field">
          <label htmlFor="interest">I&apos;m interested in</label>
          <select id="interest" name="interest" value={form.interest} onChange={onChange} data-testid="demo-interest">
            <option>QC4 GRC Platform</option>
            <option>Frontline Assurance</option>
            <option>Risk Controls &amp; Automation</option>
            <option>Digital Governance Solutions</option>
            <option>Consulting Services</option>
          </select>
        </div>
      </div>

      <div className="qc-form-row">
        <div className="qc-field">
          <label htmlFor="country">Country</label>
          <input id="country" name="country" type="text" value={form.country} onChange={onChange} placeholder="Australia" data-testid="demo-country" />
        </div>
        <div className="qc-field">
          <label htmlFor="preferredTime">Preferred time</label>
          <input id="preferredTime" name="preferredTime" type="text" value={form.preferredTime} onChange={onChange} placeholder="Weekday mornings AEST" data-testid="demo-preferredTime" />
        </div>
      </div>

      <div className="qc-form-row">
        <div className="qc-field full">
          <label htmlFor="message">What are you hoping to solve? (optional)</label>
          <textarea id="message" name="message" value={form.message} onChange={onChange}
            placeholder="e.g. Move from sample-based to 100% controls testing across our operational risk framework."
            data-testid="demo-message"
          />
        </div>
      </div>

      <div className="qc-form-submit">
        <button
          type="submit"
          className="qc-btn qc-btn-primary"
          disabled={status === 'submitting'}
          data-testid="demo-submit"
        >
          {status === 'submitting' ? 'Sending…' : 'Request my QC4 demo'}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
        </button>
        <span className="qc-form-consent">
          By submitting you agree TMR Global may contact you about QC4. Prefer to pick a time now?{' '}
          <a href="https://tidycal.com/dbenson/60-minute-meeting" target="_blank" rel="noopener noreferrer" style={{color: 'var(--accent)', textDecoration: 'underline'}} data-testid="demo-tidycal-inline">Book via TidyCal →</a>
        </span>
        {status === 'success' && (
          <div className="qc-form-success" data-testid="demo-success">{successMsg}</div>
        )}
        {status === 'error' && (
          <div className="qc-form-error" data-testid="demo-error">{errorMsg}</div>
        )}
      </div>
    </form>
  )
}
